import { BaseModel } from "sjs-base-model";

export default class IProjectPlatformModel extends BaseModel {
  public readonly name: string = "";
  public readonly slug: string = "";

  constructor(data: Partial<IProjectPlatformModel>) {
    super();

    this.update(data);
  }
}
